module.exports = __webpack_public_path__ + "img/image016.398292ff.png";